"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQuestLeaderboardsSortToJSON = exports.GetQuestLeaderboardsSortFromJSONTyped = exports.GetQuestLeaderboardsSortFromJSON = exports.GetQuestLeaderboardsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetQuestLeaderboardsSort;
(function (GetQuestLeaderboardsSort) {
    GetQuestLeaderboardsSort["PointsTotal"] = "pointsTotal";
    GetQuestLeaderboardsSort["PointsReset"] = "pointsReset";
})(GetQuestLeaderboardsSort = exports.GetQuestLeaderboardsSort || (exports.GetQuestLeaderboardsSort = {}));
function GetQuestLeaderboardsSortFromJSON(json) {
    return GetQuestLeaderboardsSortFromJSONTyped(json, false);
}
exports.GetQuestLeaderboardsSortFromJSON = GetQuestLeaderboardsSortFromJSON;
function GetQuestLeaderboardsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetQuestLeaderboardsSortFromJSONTyped = GetQuestLeaderboardsSortFromJSONTyped;
function GetQuestLeaderboardsSortToJSON(value) {
    return value;
}
exports.GetQuestLeaderboardsSortToJSON = GetQuestLeaderboardsSortToJSON;
